/**
 * The logical parent of a page, read from the menu the breadcrumb is built from (menu-items): a page that sits under
 * a menu item's url (a detail route such as /cpv/signals/12 under /cpv/signals) goes to that item; a page that IS a
 * menu item goes home (its group has no page of its own). A path the menu does not know has no parent (null), and the
 * caller falls back to history.
 */
export function menuParent(pathname, navigation, home) {
  if (!pathname || pathname === home) return null;
  let best = null;
  let bestLen = -1;
  const walk = (nodes) => {
    (nodes || []).forEach((n) => {
      if (n?.children) walk(n.children);
      if (n?.type !== 'item' || !n.url || n.url === '/') return;
      if (pathname === n.url) {
        best = { exact: true, url: n.url };
        bestLen = Number.MAX_SAFE_INTEGER;
      } else if (pathname.startsWith(`${n.url}/`) && n.url.length > bestLen) {
        best = { exact: false, url: n.url };
        bestLen = n.url.length;
      }
    });
  };
  walk(navigation?.items);
  if (!best) return null;
  return best.exact ? home : best.url;
}

export default menuParent;
